import { render, staticRenderFns } from "./OpenPre.vue?vue&type=template&id=c2b60dcc&scoped=true"
import script from "./OpenPre.vue?vue&type=script&lang=js"
export * from "./OpenPre.vue?vue&type=script&lang=js"
import style0 from "./OpenPre.vue?vue&type=style&index=0&id=c2b60dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b60dcc",
  null
  
)

export default component.exports